import { postArchiveImage } from '../api/caseDataAPI';
import {
  IMAGE_ARCHIVE_FAILURE,
  IMAGE_ARCHIVE_SUCCESS,
  INITIATE_IMAGE_ARCHIVAL,
  INITIATE_IMAGE_SELECTION,
} from './actionTypes';

export const initializeImageSelection = () => {
  return { type: INITIATE_IMAGE_SELECTION };
};

const initializeImageArchive = () => {
  return { type: INITIATE_IMAGE_ARCHIVAL };
};

const imageArchiveSuccess = (response) => {
  return {
    type: IMAGE_ARCHIVE_SUCCESS,
    archiveResponse: response.status,
  };
};

const imageArchiveFailure = (error) => {
  return {
    type: IMAGE_ARCHIVE_FAILURE,
    error,
  };
};

export const archiveImage = (documentInfo) => async (dispatch) => {
  dispatch(initializeImageArchive());
  try {
    const response = await postArchiveImage(documentInfo);
    dispatch(imageArchiveSuccess(response));
  } catch (error) {
    dispatch(imageArchiveFailure(error));
  }
};
